import { useWalletStore } from '../store/useWalletStore';
import { TransactionForm } from './TransactionForm';
import { DeviceManager } from './DeviceManager';

export function Dashboard() {
  const { balance, txs } = useWalletStore();
  return (
    <div className="space-y-6">
      <section className="rounded border border-slate-800 p-4">
        <h2 className="text-lg font-semibold">Balance</h2>
        <p className="text-3xl mt-1">{balance.toFixed(2)} USDT</p>
      </section>
      <TransactionForm />
      <DeviceManager />
      <section className="rounded border border-slate-800 p-4">
        <h3 className="font-medium">Recent transactions</h3>
        <ul className="mt-2 space-y-2">
          {txs.map(tx => (
            <li key={tx.id} className="flex justify-between border border-slate-800 rounded p-2">
              <div>
                <div className="text-sm">To: {tx.to}</div>
                <div className="text-xs text-slate-400">{new Date(tx.timestamp).toLocaleString()}</div>
              </div>
              <div className="text-right">
                <div className="font-mono">{tx.amount}</div>
                <div className="text-xs uppercase text-slate-400">{tx.status}</div>
              </div>
            </li>
          ))}
          {txs.length === 0 && <li className="text-slate-400">No transactions yet.</li>}
        </ul>
      </section>
    </div>
  );
}


